import { PENDING_CHAT_SHARE } from '../constants/local_storage_constants';

export const CHAT_SHARE_ROUTE = {
    CHAT: 'chat',
};

const SHARE_INTENT = 'share';
const VALID_ROUTES = new Set(Object.values(CHAT_SHARE_ROUTE));

const normalizeThreadId = (threadId) => String(threadId || '').trim();

export const buildPendingChatSharePath = ({ threadId, route }) => {
    const normalizedThreadId = normalizeThreadId(threadId);

    if (!normalizedThreadId || !VALID_ROUTES.has(route)) {
        return null;
    }

    return `/${route}/${encodeURIComponent(normalizedThreadId)}`;
};

export const clearPendingChatShare = () => {
    try {
        window.localStorage.removeItem(PENDING_CHAT_SHARE);
    } catch {
        // Storage can be unavailable in private browsing modes. The in-memory
        // dialog flow still works, but cannot survive a reload.
    }
};

export const getPendingChatShare = () => {
    let storedValue;

    try {
        storedValue = window.localStorage.getItem(PENDING_CHAT_SHARE);
    } catch {
        return null;
    }

    if (!storedValue) {
        return null;
    }

    try {
        const pendingShare = JSON.parse(storedValue);
        const threadId = normalizeThreadId(pendingShare && pendingShare.threadId);
        const route = pendingShare && pendingShare.route;
        const path = buildPendingChatSharePath({ threadId, route });

        if (
            !pendingShare ||
            pendingShare.intent !== SHARE_INTENT ||
            !threadId ||
            !path ||
            pendingShare.path !== path
        ) {
            clearPendingChatShare();
            return null;
        }

        return {
            intent: SHARE_INTENT,
            threadId,
            route,
            path,
        };
    } catch {
        clearPendingChatShare();
        return null;
    }
};

export const setPendingChatShare = ({ threadId, route }) => {
    const normalizedThreadId = normalizeThreadId(threadId);
    const path = buildPendingChatSharePath({
        threadId: normalizedThreadId,
        route,
    });

    if (!path) {
        return null;
    }

    const pendingShare = {
        intent: SHARE_INTENT,
        threadId: normalizedThreadId,
        route,
        path,
    };

    try {
        window.localStorage.setItem(PENDING_CHAT_SHARE, JSON.stringify(pendingShare));
    } catch {
        return null;
    }

    return pendingShare;
};

export const hasPendingChatShare = ({ threadId, route }) => {
    const pendingShare = getPendingChatShare();

    return Boolean(
        pendingShare &&
        pendingShare.threadId === normalizeThreadId(threadId) &&
        pendingShare.route === route,
    );
};
